import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Form, Typography, Table, Button, Input, Icon, Modal, Spin } from 'antd';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { green } from '@material-ui/core/colors';
import 'antd/dist/antd.css';
import Highlighter from 'react-highlight-words';
import './OutOfStockRecipientList.css';

const { Title } = Typography;

@inject('outOfStockRecipientStore')
@observer
class OutOfStockRecipientList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
    }

    // ON CLICK

    createOrUpdateCategoryOnClick = () => this.props.outOfStockRecipientStore.createOrUpdateCategory();

    createClicked = () => this.props.outOfStockRecipientStore.initCreate();

    updateClicked = outOfStockRecipientId => this.props.outOfStockRecipientStore.initUpdate(outOfStockRecipientId);

    removeClicked = outOfStockRecipientId => this.props.outOfStockRecipientStore.deleteOutOfStockRecipient(outOfStockRecipientId);

    deleteClicked = outOfStockRecipientId => {
        Modal.confirm({
            title: 'Remove Out of Stock Recipient',
            content: 'Are you sure to remove out of stock recipient?',
            okText: 'Remove',
            cancelText: 'Cancel',
            onOk: () => this.removeClicked(outOfStockRecipientId)
        });
    }

    getColumns = () => {
        return [
            {
                title: 'Email',
                dataIndex: 'email',
                key: 'email',
                ...this.getColumnSearchProps('email')
            },
            {
                title: 'Action',
                dataIndex: 'outOfStockRecipientId',
                key: 'outOfStockRecipientId',
                render: outOfStockRecipientId => (
                    <span>
                        <Button onClick={() => this.updateClicked(outOfStockRecipientId)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <EditIcon style={{ color: '#1890ff', fontSize: 24 }} />
                        </Button>
                        <Button onClick={() => this.deleteClicked(outOfStockRecipientId)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <DeleteIcon style={{ color: '#DC004E', fontSize: 24 }} />
                        </Button>
                    </span>
                ),
            },
        ]
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type='primary'
                    onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    icon='search'
                    size='small'
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
            </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size='small' style={{ width: 90 }}>
                    Reset
            </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type='search' style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                    text
                ),
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters()
        this.setState({ searchText: '' })
    }

    render() {
        const {
            outOfStockRecipients,
            listLoading,
        } = this.props.outOfStockRecipientStore;

        return (
            <React.Fragment>
                <Form layout='horizontal'>
                    <div style={{ marginBottom: 20, marginTop: 20 }}>
                        <Title level={3} style={{ width: '80%', position: 'relative', float: 'left' }}>List</Title>
                        <div style={{ textAlign: 'right' }}>
                            <button type='button' style={{ border: 'none', background: 'none', cursor: 'pointer' }} onClick={this.createClicked}>
                                <AddCircleIcon style={{ color: green[500], fontSize: 45 }} />
                            </button>
                        </div>
                    </div>
                    <Spin spinning={listLoading}>
                        <Table columns={this.getColumns()} dataSource={outOfStockRecipients} />
                    </Spin>
                </Form>
            </React.Fragment>
        )
    }
}

export default OutOfStockRecipientList;